export default __webpack_public_path__ + "static/media/default_project_image.57070e84.png";